var _circle, _circle2, _circle3, _path, _circle4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubnetpoolsDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4,
    r: 2.5,
    fill: "url(#g1_snp)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 14,
    r: 2.5,
    fill: "url(#g2_snp)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 2.5,
    fill: "url(#g3_snp)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5V9M8 10.5L5.5 12M12 10.5L14.5 12",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1.5,
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1_snp",
    x1: 10,
    y1: 1.5,
    x2: 10,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2_snp",
    x1: 4,
    y1: 11.5,
    x2: 4,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3_snp",
    x1: 16,
    y1: 11.5,
    x2: 16,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubnetpoolsDefault);
export default __webpack_public_path__ + "static/media/subnetpools-default.878d1229254f2ab8955b64493e536552.svg";
export { ForwardRef as ReactComponent };